import { Grid, IconButton, TextField } from '@mui/material';

import React, { useCallback, useState } from 'react';

import { debounce } from 'lodash';

import { nextPaginationIcon, prevPaginationIcon } from 'common/assets/images';
import { onPageTextChanged } from 'common/components/Table/CommonTableStyles';
import { ImgTagComponent } from 'common/utils/utilFunctions';

import { IGetTaxonomyHeatMapParams } from '../../api/type-def';

import paginationStyles from './RiskTaxonomyHeatMap.module.scss';

interface IHeatMapViewPaginationProps {
	defaultTableQueryParams: IGetTaxonomyHeatMapParams;
	totalPagesCount: number;
	handlePageChange?: (data: IGetTaxonomyHeatMapParams) => void;
}
const HeatMapViewPagination = (props: IHeatMapViewPaginationProps) => {
	const { defaultTableQueryParams, totalPagesCount, handlePageChange } = props;
	const queryPageNum = defaultTableQueryParams?.pageNumber || 0;
	const [textFieldPage, setTextFieldPage] = useState<any>(queryPageNum);
	const [page, setPage] = React.useState(queryPageNum);
	const handlePagination = (hPage: number) => {
		const paramData = { pageNumber: hPage - 1 };
		setPage(hPage);
		setTextFieldPage(hPage);
		if (handlePageChange) {
			handlePageChange(paramData);
		}
	};
	const onPageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = parseInt(event.target.value, 10);
		const resultValue = onPageTextChanged(
			value,
			undefined,
			undefined,
			totalPagesCount,
		);
		const paramData = { pageNumber: resultValue - 1 };
		setPage(resultValue);
		setTextFieldPage(resultValue);
		if (handlePageChange) {
			handlePageChange(paramData);
		}
	};
	const debouncedOnPageSelect = useCallback(debounce(onPageSelect, 500), []);
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTextFieldPage(event.target.value);
		debouncedOnPageSelect(event);
	};

	return (
		<Grid item xs={6} className={paginationStyles['common-table-pages-grid']}>
			<IconButton
				aria-label="delete"
				data-testid="servertable-prev-icon"
				onClick={() => {
					handlePagination(page - 1);
				}}
				className={paginationStyles['common-table-icon-button-prev']}
				disabled={page === 1}
			>
				{ImgTagComponent(
					prevPaginationIcon,
					'prevPaginationIcon',
					'prev-pagination-styles',
				)}
			</IconButton>
			<TextField
				id="outlined-size-small"
				value={textFieldPage}
				size="small"
				className={paginationStyles['common-table-pages-grid-input-field']}
				onChange={(e: any) => handleChange(e)}
				inputProps={{
					'data-testid': 'servertable-pagenumber-textfield',
				}}
			/>
			of {totalPagesCount}
			<IconButton
				aria-label="delete"
				data-testid="servertable-next-icon"
				onClick={() => {
					handlePagination(page + 1);
				}}
				className={paginationStyles['common-table-icon-button-next']}
				disabled={page === totalPagesCount}
			>
				{ImgTagComponent(
					nextPaginationIcon,
					'nextPaginationIcon',
					'next-pagination-styles',
				)}
			</IconButton>
		</Grid>
	);
};

export default HeatMapViewPagination;
